import { getCurrentLocalhostPort } from "../util/PortUtils";
export const getLoginURL = () => {
    // Beta & Prod share a user pool
    const BASE_URL = "https://auth.mediashare.link/oauth2/authorize?response_type=token&client_id=5g9240lj7oj1ckpr7c9fsasss1&scope=openid+aws.cognito.signin.user.admin+profile+email+phone&redirect_uri=";
    const localhostPort = getCurrentLocalhostPort();
    if (localhostPort) {
        return BASE_URL + `http://localhost:${localhostPort}/authcb.html`;
    }
    else if (window.location.href.includes("test.mediashare.link")) {
        return BASE_URL + "https://test.mediashare.link/authcb.html";
    }
    else {
        return BASE_URL + "https://www.mediashare.link/authcb.html";
    }
};
export const getCodeLoginURL = () => {
    // Beta & Prod share a user pool
    const BASE_URL = "https://auth.mediashare.link/oauth2/authorize?response_type=code&client_id=5g9240lj7oj1ckpr7c9fsasss1&scope=openid+aws.cognito.signin.user.admin+profile+email+phone&redirect_uri=";
    const localhostPort = getCurrentLocalhostPort();
    if (localhostPort) {
        return BASE_URL + `http://localhost:${localhostPort}/authcb.html`;
    }
    else if (window.location.href.includes("test.mediashare.link")) {
        return BASE_URL + "https://test.mediashare.link/authcb.html";
    }
    else {
        return BASE_URL + "https://www.mediashare.link/authcb.html";
    }
};
export const doLogoutRedirect = () => {
    const BASE_URL = "https://auth.mediashare.link/logout?response_type=token&client_id=5g9240lj7oj1ckpr7c9fsasss1&scope=openid+aws.cognito.signin.user.admin+profile+email+phone&logout_uri=";
    const localhostPort = getCurrentLocalhostPort();
    if (localhostPort) {
        window.location.href =
            BASE_URL + `http://localhost:${localhostPort}/Logout`;
    }
    else if (window.location.href.includes("test.mediashare.link")) {
        window.location.href = BASE_URL + "https://test.mediashare.link/Logout";
    }
    else {
        window.location.href = BASE_URL + "https://www.mediashare.link/Logout";
    }
};
const forcedLoginTargetKey = "forcedLoginTargetKey";
export const forceLogin = (navigate) => {
    const location = "/login";
    const fromLocation = window.location.href;
    console.log("forceLogin: to = " + location + ", from = " + fromLocation);
    saveLoginRedirect(fromLocation);
    navigate(location);
};
const cleanUrlFromTracking = (url) => {
    try {
        const urlObj = new URL(url);
        // Remove Facebook click tracking parameter
        urlObj.searchParams.delete("fbclid");
        // Remove other common tracking parameters that shouldn't be preserved
        urlObj.searchParams.delete("utm_source");
        urlObj.searchParams.delete("utm_medium");
        urlObj.searchParams.delete("utm_campaign");
        urlObj.searchParams.delete("utm_term");
        urlObj.searchParams.delete("utm_content");
        urlObj.searchParams.delete("gclid"); // Google click tracking
        urlObj.searchParams.delete("_ga"); // Google Analytics
        return urlObj.toString();
    }
    catch (error) {
        console.warn("cleanUrlFromTracking: Invalid URL, using as-is", url, error);
        return url;
    }
};
export const saveLoginRedirect = (location) => {
    // Don't save redirects to auth-related pages or welcome page to prevent loops
    if (location.includes("/authcb") ||
        location.includes("/Login") ||
        location.includes("/Logout") ||
        location.includes("/Welcome") ||
        location.includes("/login")) {
        console.log("saveLoginRedirect: Skipping auth/welcome page", location);
        return;
    }
    // Clean the URL from tracking parameters before saving
    const cleanedLocation = cleanUrlFromTracking(location);
    const savedRedirect = {
        url: cleanedLocation,
        timestamp: Date.now(),
    };
    localStorage.setItem(forcedLoginTargetKey, JSON.stringify(savedRedirect));
    console.log("saveLoginRedirect: Saved cleaned redirect to", cleanedLocation);
};
export const restoreFromForcedLogin = () => {
    const savedData = localStorage.getItem(forcedLoginTargetKey);
    if (!savedData) {
        return false;
    }
    try {
        const savedRedirect = JSON.parse(savedData);
        const now = Date.now();
        const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds
        // Check if the saved redirect has expired (1 hour)
        if (now - savedRedirect.timestamp > oneHour) {
            console.log("restoreFromForcedLogin: Saved redirect expired, clearing");
            localStorage.removeItem(forcedLoginTargetKey);
            return false;
        }
        const restoreUrl = savedRedirect.url;
        // Additional loop prevention - don't redirect to auth pages
        if (restoreUrl.includes("/authcb") ||
            restoreUrl.includes("/Login") ||
            restoreUrl.includes("/Logout") ||
            restoreUrl.includes("/Welcome") ||
            restoreUrl.includes("/login")) {
            console.log("restoreFromForcedLogin: Preventing redirect to auth page", restoreUrl);
            localStorage.removeItem(forcedLoginTargetKey);
            return false;
        }
        console.log("restoreFromForcedLogin: restore URL = " + restoreUrl);
        // Clear the saved redirect BEFORE attempting the redirect to prevent loops
        localStorage.removeItem(forcedLoginTargetKey);
        setTimeout(() => {
            window.location.href = restoreUrl;
        }, 50);
        return true;
    }
    catch (error) {
        console.error("restoreFromForcedLogin: Error parsing saved redirect", error);
        localStorage.removeItem(forcedLoginTargetKey);
        return false;
    }
};
export const clearRestoreURL = () => {
    console.log("clearRestoreURL");
    localStorage.removeItem(forcedLoginTargetKey);
};
